import React, { useState } from 'react';
import { FaTimes, FaMapMarkerAlt, FaHome, FaPencilAlt, FaPhoneAlt } from 'react-icons/fa';
import PaymentModal from './PaymentModal'; 

const AddressModal = ({ carData, onClose }) => {
  const [address, setAddress] = useState({});
  const [error, setError] = useState(null);
  const [isPaymentStep, setIsPaymentStep] = useState(false);

  const handleFormChange = (e) => {
    setAddress({ ...address, [e.target.name]: e.target.value });
  };

  const handleNextStep = (e) => {
    e.preventDefault();
    setError(null);
    
    // Basic validation
    if (!address.landmark || !address.houseName || !address.pinCode || !address.mobileNo) {
        return setError("All address fields are required.");
    }
    if (address.mobileNo.length < 10) {
        return setError("Please enter a valid 10-digit mobile number.");
    }

    // Proceed to payment
    setIsPaymentStep(true);
  };

  if (isPaymentStep) {
    // Pass carData and collected address to the Payment Modal
    return (
      <PaymentModal 
        {...carData} 
        address={address} // Pass the collected address
        onClose={onClose}
        // Note: onPaymentSuccess will be handled by PaymentModal itself
      />
    );
  }

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content bg-slate-800" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button text-white">
          <FaTimes />
        </button>
        
        <h2 className="text-2xl font-bold text-amber-400 mb-2 border-b border-slate-700 pb-2">
            <FaMapMarkerAlt className="inline mr-2" /> Enter Delivery Address
        </h2>
        <p className="text-slate-400 mb-6">
            Please provide the exact location for your {carData.carName} rental.
        </p>

        {error && (
            <div className="p-3 bg-red-600 text-white rounded-lg mb-4 text-sm font-medium">{error}</div>
        )}
        
        <form onSubmit={handleNextStep} className="space-y-4">
          
          <div className="relative">
            <FaHome className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              name="houseName"
              placeholder="House Name / Flat No."
              onChange={handleFormChange}
              required
              className="w-full py-3 pl-12 pr-4 bg-slate-900 text-white rounded-lg border border-slate-700 focus:ring-amber-400 focus:border-amber-400"
            />
          </div>
          
          <div className="relative">
            <FaPencilAlt className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" />
            <input
              type="text"
              name="landmark"
              placeholder="Landmark / Street Address"
              onChange={handleFormChange}
              required
              className="w-full py-3 pl-12 pr-4 bg-slate-900 text-white rounded-lg border border-slate-700 focus:ring-amber-400 focus:border-amber-400"
            />
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="relative">
              <input
                type="text"
                name="pinCode"
                placeholder="Pin Code"
                onChange={handleFormChange}
                maxLength="6"
                required
                className="w-full py-3 px-4 bg-slate-900 text-white rounded-lg border border-slate-700 focus:ring-amber-400 focus:border-amber-400"
              />
            </div>
            <div className="relative">
              <FaPhoneAlt className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400" />
              <input
                type="tel"
                name="mobileNo"
                placeholder="Mobile No."
                onChange={handleFormChange}
                maxLength="10"
                required
                className="w-full py-3 pl-12 pr-4 bg-slate-900 text-white rounded-lg border border-slate-700 focus:ring-amber-400 focus:border-amber-400"
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full py-3 bg-amber-400 text-slate-950 font-bold rounded-lg hover:bg-amber-500 transition duration-300 shadow-md"
          >
            Proceed to Payment
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddressModal;